
import WebService from "../WebService"
const Ticket = {
    gets(params) {
        return WebService.get("/tickets?" + params)
    },
    getListWithAttendeeInfoForm(params) {
        return WebService.get("/tickets-with-attendee-info-form?" + params)
    },
    get(ticket,e,s) {
        return WebService.get("/tickets/" + ticket+"?e="+e+"&s="+s)
    },
    update(data) {
        return WebService.post("/tickets/" + data.ticket, data)
    },
    action(data) {
        return WebService.post("/tickets/" + data.ticket + "/status?e=" + data.e, data)
    },
    history(params) {
        return WebService.get("/tickets/history?" + params)
    },
    uploadAnswer(ticket, field_no, data) {
        return WebService.post(`/tickets/${ticket}/answer/${field_no}/upload`, data)
    }
}
export default Ticket
